/** DEV OPTS*/
/* @flow */
/* eslint-env node*/
/* eslint-disable no-console */
/*
 * Coach Amigo React STREAM
 * https://github.com/facebook/react-native
 *
 *
 * usage:
 * style has extra features xs,sm,smUp,smDown,md,mdUp,mdDown, etc...
 * style={{sm:{display:'block'}}}
 */
import type { Props } from './../types/types';

import React from 'react';

const breakpoints = {
   xs: 440,
   sm: 576,
   md: 768,
   lg: 992,
   xl: 1200
};

export const ResponsiveView = (props: Props): any => {
   if (!props) props = {};
   props = {
      className: 'view',
      children: null,
      style: {},
      ...props
   };

   const getSize = () => {
      return {
         width: window.innerWidth,
         height: window.innerHeight
      };
   };

   const [windowSize, setWindowSize] = React.useState(getSize);

   React.useEffect(() => {
      const handleResize = () => {
         setWindowSize(getSize());
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   let xs = props.style.xs ? { ...props.style.xs } : null;
   let sm = props.style.sm ? { ...props.style.sm } : null;
   let md = props.style.md ? { ...props.style.md } : null;
   let lg = props.style.lg ? { ...props.style.lg } : null;
   let xl = props.style.xl ? { ...props.style.xl } : null;

   let smDown = props.style.smDown ? { ...props.style.smDown } : null;
   let mdDown = props.style.mdDown ? { ...props.style.mdDown } : null;
   let lgDown = props.style.lgDown ? { ...props.style.lgDown } : null;

   let smUp = props.style.smUp ? { ...props.style.smUp } : null;
   let mdUp = props.style.mdUp ? { ...props.style.mdUp } : null;
   let lgUp = props.style.lgUp ? { ...props.style.lgUp } : null;

   let rStyle = { ...props.style };
   if (rStyle.xs) delete rStyle.xs;
   if (rStyle.sm) delete rStyle.sm;
   if (rStyle.md) delete rStyle.md;
   if (rStyle.lg) delete rStyle.lg;
   if (rStyle.xl) delete rStyle.xl;
   if (rStyle.smDown) delete rStyle.smDown;
   if (rStyle.mdDown) delete rStyle.mdDown;
   if (rStyle.lgDown) delete rStyle.lgDown;
   if (rStyle.smUp) delete rStyle.smUp;
   if (rStyle.mdUp) delete rStyle.mdUp;
   if (rStyle.lgUp) delete rStyle.lgUp;

   if (xs && windowSize.width < breakpoints.sm) rStyle = { ...rStyle, ...xs };
   if (smDown && windowSize.width <= breakpoints.sm) rStyle = { ...rStyle, ...smDown };
   if (mdDown && windowSize.width <= breakpoints.md) rStyle = { ...rStyle, ...mdDown };
   if (lgDown && windowSize.width <= breakpoints.lg) rStyle = { ...rStyle, ...lgDown };

   if (sm && windowSize.width >= breakpoints.sm && windowSize.width < breakpoints.md) rStyle = { ...rStyle, ...sm };
   if (md && windowSize.width >= breakpoints.md && windowSize.width < breakpoints.lg) rStyle = { ...rStyle, ...md };
   if (lg && windowSize.width >= breakpoints.lg && windowSize.width < breakpoints.xl) rStyle = { ...rStyle, ...lg };

   if (smUp && windowSize.width >= breakpoints.sm) rStyle = { ...rStyle, ...smUp };
   if (mdUp && windowSize.width >= breakpoints.md) rStyle = { ...rStyle, ...mdUp };
   if (lgUp && windowSize.width >= breakpoints.lg) rStyle = { ...rStyle, ...lgUp };
   if (xl && windowSize.width >= breakpoints.xl) rStyle = { ...rStyle, ...xl };

   return (
      <div className={props.className} style={rStyle}>
         {props.children}
      </div>
   );
};

export default React.memo(ResponsiveView);
